import { Authentication, LoginFormType } from "../types/authen";
import { fetcher } from "../utils/fetch";

const isMockAuthEnabled = () =>
  String(import.meta.env.VITE_MOCK_AUTH).toLowerCase() === "true";

const base64UrlEncode = (value: object) =>
  btoa(JSON.stringify(value))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");

const createMockAccessToken = (role: string) => {
  const header = base64UrlEncode({ alg: "none", typ: "JWT" });
  const payload = base64UrlEncode({
    exp: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 7,
    role,
  });
  return `${header}.${payload}.mock`;
};

const resolveMockRole = (username?: string) => {
  const normalized = (username ?? "").toLowerCase();
  if (normalized.includes("admin")) return "admin";
  if (normalized.includes("crm")) return "crm";
  if (normalized.includes("reward")) return "reward";
  if (normalized.includes("member") || normalized.includes("user"))
    return "member";
  return "member";
};

const resolveMockDuties = (role: string) => {
  if (role === "member") {
    return ["task", "keyin", "support", "qc"];
  }
  if (role === "crm") {
    return ["crm"];
  }
  if (role === "reward") {
    return ["reward"];
  }
  return [];
};

const createMockAuth = (data: LoginFormType): Authentication => {
  const role = resolveMockRole(data?.username);
  const safeName =
    data?.username?.trim() ||
    (role === "admin"
      ? "Admin User"
      : role === "crm"
        ? "CRM Specialist"
        : role === "reward"
          ? "Reward Specialist"
          : "Member User");
  const emailLocal = safeName.toLowerCase().replace(/[^a-z0-9]+/g, ".");
  return {
    access_token: createMockAccessToken(role),
    user_id: `mock-${role}-001`,
    name: safeName,
    role,
    duties: resolveMockDuties(role),
    email: `${emailLocal || "user"}@mock.local`,
    image: "",
    mobile_no: "",
    expire_at: Date.now() + 60 * 60 * 24 * 7 * 1000 - 15000,
  };
};

const login = async (data: LoginFormType) => {
  if (isMockAuthEnabled()) {
    return createMockAuth(data);
  }
  return await fetcher<Authentication>("POST", "login", data, null, null, true);
};

export { login };
